import React, { PropsWithChildren } from 'react';
import { Text, Box, InlineLink } from '@fullstory/components';
import css from './index.module.scss';
import { FormattedMessage } from 'react-intl';

interface FooterProps {
  freePath?: string; // If unset, will not show a free link option.
}

export const Footer: React.FC<PropsWithChildren<FooterProps>> = ({ freePath, children }) => (
  <Box data-component="Footer" className={css.footer} marginTop={8}>
    {children}
    {freePath ? (
      <>
        <Text appearance="bodyMedium">Not ready to decide?&nbsp;</Text>
        <Text appearance="bodyMedium" color="secondary">
          <InlineLink href={freePath} newTab>
            <FormattedMessage defaultMessage="Go Free" id="uBQled" />
          </InlineLink>
        </Text>
      </>
    ) : (
      <Text appearance="bodyMedium" color="secondary">
        <InlineLink href="https://www.fullstory.com/plans/" newTab>
          <FormattedMessage defaultMessage="Learn more about our plans" id="m/rwJs" />
        </InlineLink>
      </Text>
    )}
  </Box>
);
